export default "__VITE_ASSET__CTzUSPeO__"